import type { Nft, ReadApiCompressionMetadata, ReadApiOwnershipMetadata, Sft } from "@metaplex-foundation/js";
import type { IStarAtlasPosterData } from "@stepfinance/dex";
import type { NFT } from "@stepfinance/nft";
import type { NormalizedTokenAccount } from "@stepfinance/tokens";

export type MetaplexNFT = Nft | Sft;

// NFT object narrowed with defined ATA for transaction operations
export type NFTWithTokenAccount = NFT & {
  associatedTokenAccount: NormalizedTokenAccount;
};

export type CompressedNFT = NFT & {
  compression: ReadApiCompressionMetadata;
  ownership: ReadApiOwnershipMetadata;
};

export type StarAtlasNFT = Omit<NFT, "json"> & {
  json: IStarAtlasPosterData;
};

export const isNFTWithTokenAccount = (nft: any): nft is NFTWithTokenAccount =>
  typeof nft === "object" && typeof nft.associatedTokenAccount === "object";

export const isCompressedNFT = (nft: any): nft is CompressedNFT =>
  typeof nft === "object" && typeof nft.compression === "object";

export const isStarAtlasNFT = (nft: any): nft is StarAtlasNFT => !!nft.json && typeof nft.json.media === "object";

export const isMarinadeNFT = (nft: any): nft is NFT =>
  !!nft.json && !!nft.json.properties && typeof nft.json.properties.mnde_amount === "number";
